module.exports = __webpack_public_path__ + "img/qq_code.ac6076d7.jpg";